import React, { Component } from "react";

class Social extends Component {
  state = {};
  render() {
    const { isVisible } = this.props;

    const classes = isVisible ? "is-visible" : "not-visible";

    return (
      <ul
        className={`social-icons ${classes}`}
        style={{
          display: "flex",
          justifyContent: "space-between",
          listStyle: "none",
          marginTop: "50px"
        }}
      >
        <li>
          <a href="https://twitter.com/timarney" title="twitter">
            <svg
              style={{ paddingTop: "2px" }}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 612 612"
            >
              <path
                d="M612 116.258c-22.525 9.98-46.694 16.75-72.088 19.772 25.93-15.527 45.777-40.155 55.184-69.41-24.322 14.378-51.17 24.82-79.775 30.48-22.906-24.438-55.49-39.66-91.63-39.66-69.333 0-125.55 56.218-125.55 125.514 0 9.828 1.11 19.427 3.25 28.606-104.325-5.24-196.834-55.223-258.75-131.174-10.822 18.51-16.98 40.078-16.98 63.1 0 43.56 22.182 81.994 55.836 104.48-20.575-.688-39.926-6.348-56.867-15.756v1.568c0 60.806 43.29 111.554 100.692 123.104-10.517 2.83-21.607 4.398-33.08 4.398-8.107 0-15.947-.803-23.634-2.333 15.985 49.907 62.336 86.2 117.253 87.194-42.946 33.655-97.098 53.656-155.915 53.656-10.134 0-20.116-.612-29.944-1.72 55.568 35.68 121.537 56.484 192.44 56.484 230.947 0 357.187-191.29 357.187-357.188l-.42-16.253C573.87 163.525 595.21 141.42 612 116.257z"
                fill="#010002"
              />
            </svg>
          </a>
        </li>

        <li>
          <a href="https://github.com/timarney" title="github">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 1.787 800 799.213"
            >
              <ellipse
                fill="#f5f5f5"
                cx="400.106"
                cy="410.145"
                rx="394.606"
                ry="390.855"
              />
              <path d="M746.338 201.004c-35.77-61.286-84.287-109.806-145.567-145.57-61.29-35.768-128.2-53.647-200.778-53.647-72.567 0-139.497 17.885-200.775 53.646-61.286 35.763-109.802 84.285-145.57 145.57C17.882 262.29 0 329.21 0 401.77c0 87.16 25.43 165.537 76.3 235.15 50.867 69.618 116.578 117.792 197.13 144.525 9.375 1.74 16.317.516 20.832-3.642 4.513-4.162 6.768-9.376 6.768-15.618 0-1.04-.09-10.413-.263-28.124-.18-17.712-.263-33.163-.263-46.345l-11.98 2.072c-7.637 1.4-17.274 1.992-28.905 1.824-11.63-.163-23.7-1.38-36.2-3.647-12.502-2.243-24.133-7.45-34.896-15.61-10.76-8.16-18.397-18.84-22.912-32.026l-5.208-11.985c-3.47-7.98-8.938-16.843-16.403-26.56-7.466-9.724-15.016-16.316-22.656-19.788l-3.645-2.608c-2.43-1.736-4.686-3.83-6.77-6.257-2.084-2.427-3.644-4.858-4.687-7.292-1.04-2.436-.177-4.433 2.605-6.002 2.782-1.565 7.808-2.326 15.104-2.326l10.412 1.557c6.945 1.392 15.535 5.55 25.782 12.496 10.243 6.944 18.66 15.97 25.26 27.076 7.99 14.24 17.616 25.09 28.906 32.558 11.28 7.466 22.656 11.193 34.112 11.193s21.35-.868 29.685-2.596c8.327-1.732 16.14-4.345 23.435-7.814 3.125-23.273 11.633-41.154 25.517-53.65-19.787-2.08-37.58-5.21-53.382-9.376-15.794-4.17-32.115-10.938-48.952-20.32-16.847-9.372-30.822-21.01-41.93-34.89-11.108-13.89-20.226-32.125-27.338-54.69-7.114-22.57-10.675-48.61-10.675-78.12 0-42.022 13.718-77.78 41.148-107.295-12.85-31.593-11.638-67.007 3.643-106.242 10.07-3.13 25.002-.78 44.792 7.028 19.792 7.815 34.284 14.508 43.49 20.057 9.204 5.545 16.58 10.25 22.136 14.06 32.3-9.023 65.63-13.535 100.002-13.535 34.374 0 67.707 4.51 100.007 13.536l19.792-12.496c13.532-8.337 29.516-15.975 47.903-22.92 18.406-6.942 32.477-8.853 42.203-5.727 15.62 39.24 17.012 74.653 4.16 106.242 27.427 29.516 41.15 65.285 41.15 107.296 0 29.512-3.572 55.632-10.677 78.378-7.114 22.748-16.31 40.966-27.592 54.69-11.29 13.717-25.354 25.264-42.192 34.63-16.843 9.378-33.17 16.146-48.96 20.313-15.805 4.17-33.596 7.304-53.385 9.387 18.05 15.62 27.075 40.274 27.075 73.953v109.884c0 6.243 2.17 11.456 6.516 15.62 4.342 4.154 11.193 5.38 20.57 3.637 80.56-26.73 146.272-74.904 197.137-144.523 50.86-69.612 76.3-147.99 76.3-235.15-.02-72.55-17.91-139.468-53.657-200.753h-.005z" />
            </svg>
          </a>
        </li>

        <li>
          <a href="https://www.linkedin.com/in/timarney/" title="linkedin">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
              <ellipse
                fill="#F5F5F5"
                cx="399.498"
                cy="412.684"
                rx="382.002"
                ry="376.816"
              />
              <path d="M740.923 0H59.113C26.47 0 .006 25.654.006 57.318v685.337c0 31.668 26.47 57.343 59.11 57.343h681.808c32.643 0 59.072-25.69 59.072-57.343V57.32c0-31.657-26.43-57.318-59.072-57.318V0zM242.54 669.654H121.665v-361.19H242.54v361.19zM182.114 259.12h-.813c-40.534 0-66.81-27.72-66.81-62.426 0-35.404 27.047-62.374 68.385-62.374 41.34 0 66.772 26.962 67.572 62.374 0 34.712-26.222 62.426-68.335 62.426zm496.137 410.534H557.416v-193.25c0-48.557-17.508-81.688-61.205-81.688-33.428 0-53.272 22.352-61.986 43.933-3.23 7.706-4.03 18.486-4.03 29.252v201.745H309.386s1.58-327.314 0-361.188h120.828v51.204c16.04-24.604 44.704-59.705 108.87-59.705 79.532 0 139.166 51.594 139.166 162.587v207.105l.002.002zm-248.82-308.842c.204-.338.494-.744.78-1.142v1.142h-.78z" />
            </svg>
          </a>
        </li>

        <li>
          <a href="https://medium.com/@timarney" title="medium.com">
            <svg
              style={{ paddingTop: "5px" }}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 800 800"
            >
              <path d="M800 85.714h-44.145c-11.49 0-41.57 12.486-41.57 23.114v386.01c0 10.655 30.075 19.394 41.57 19.394h44.147v85.7H514.284V514.23h57.157V114.268h-9.945L423.957 599.93H317.47L181.713 114.268h-10.284v399.958h57.134v85.705H0v-85.704h31.7c12.445 0 25.434-8.732 25.434-19.39V108.83c0-10.63-12.987-23.114-25.434-23.114H0V0h296.21l96.714 342.813h2.604L493.198 0H800v85.714z" />
            </svg>
          </a>
        </li>
      </ul>
    );
  }
}

export default Social;



// WEBPACK FOOTER //
// ./src/components/Social.js